import React, { useEffect, useState } from 'react'
import { Divider, Table } from 'semantic-ui-react'
import { InfoValidadosEvaluados } from './InfoValidadosEvaluados'
import { resumenParticipacion } from '../../utils/Datos';
import {Modal} from '../Otros/Modal';


export const ReportePrecalificadores = ({id_process,officer_id=null}) => {
    const [datos, setdatos] = useState(null);
    const [pendientes, setpendientes] = useState(null);
    const [cargandoDatos, setCargandoDatos] = useState(false);
    const [validadas, setvalidadas] = useState(false)
    const [evaluadas, setevaluadas] = useState(false)

    useEffect(() => {
      resumenParticipacion(id_process).then((result)=>{
        console.log(result[0]["name_officer"]);
        setdatos(result);
      })
    }, [])
    
  return (
    <div>
        {datos !=null ? <Table celled structured padded striped>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell verticalAlign='middle' rowSpan='2'>Precalificador</Table.HeaderCell>
                    <Table.HeaderCell verticalAlign='middle' rowSpan='2' textAlign='center'>Total de Participantes</Table.HeaderCell>
                    <Table.HeaderCell colSpan='3'>Etapas de evaluación</Table.HeaderCell>
                </Table.Row>
                <Table.Row>
                    <Table.HeaderCell>Primera evaluación</Table.HeaderCell>
                    <Table.HeaderCell>Segunda Evaluación</Table.HeaderCell>
                    <Table.HeaderCell>Precalificación</Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>
                {
                    datos.map((d,index)=>{
                        if (officer_id === null || d["officer_id"] === officer_id){
                        return <Table.Row key={`${index}_row`}>
                        <Table.Cell verticalAlign='middle'>
                            {d["name_officer"]}
                            <br/>
                            {/*<p className='text-muted'>Dirección de informática</p>*/}
                        </Table.Cell>
                        <Table.Cell verticalAlign='middle' textAlign='center'><h2>{d["number_participants"]}</h2></Table.Cell>
                        <Table.Cell>
                            <InfoValidadosEvaluados 
                                id_officer={d["officer_id"]}
                                id_process={id_process}
                                totalParticipantes={d["number_participants"]}
                                noEvaluados={d["noeval_FirstEvaluation"]}
                                noValidados={d["noValidadas_FirstEvaluation"]}
                                setpendientes={setpendientes}
                                setCargandoDatos={setCargandoDatos}
                                setevaluadas={setevaluadas}
                                setvalidadas={setvalidadas}
                                etapa={`Primera Evaluación`}
                                titulo_evaluados='Funcionarios evaluados'
                            />
                            
                        </Table.Cell>
    
                        <Table.Cell>
                            <InfoValidadosEvaluados 
                                id_officer={d["officer_id"]}
                                id_process={id_process}
                                totalParticipantes={d["number_participants"]}
                                noEvaluados={d["noeval_SecondEvaluation"]}
                                noValidados={d["noValidadas_SecondEvaluation"]}
                                setpendientes={setpendientes}
                                setCargandoDatos={setCargandoDatos}
                                setevaluadas={setevaluadas}
                                setvalidadas={setvalidadas}
                                etapa={`Segunda Evaluación`}
                                titulo_evaluados='Funcionarios evaluados'
                            />
                            
                        </Table.Cell>
                        <Table.Cell>
                            <InfoValidadosEvaluados 
                                id_officer={d["officer_id"]}
                                id_process={id_process}
                                totalParticipantes={d["number_participants"]}
                                noEvaluados={d["noeval_ThirdEvaluation"]}
                                setpendientes={setpendientes}
                                setCargandoDatos={setCargandoDatos}
                                setevaluadas={setevaluadas}
                                setvalidadas={setvalidadas}
                                etapa={`Pre Calificación`}
                                noValidados={d["noValidadas_ThirdEvaluation"]}
                                titulo_evaluados='Funcionarios precalificados'
                            />
                            
                        </Table.Cell>
                        </Table.Row>
                        }
                        return null;
                    })
                }
                
               
            </Table.Body>
        </Table> : <center>No hay información para este proceso</center>}

        <Modal id={`modal_pendientes`} title={`Detalles`}>
                {
                   cargandoDatos ? 
                   <center>Cargando pendientes</center>
                   :
                   pendientes !=null && pendientes!=[] ? 
                   <Table>
                   <Table.Header>
                       <Table.Row>
                           <Table.HeaderCell>Funcionario</Table.HeaderCell>
                           <Table.HeaderCell>Rut</Table.HeaderCell>
                           <Table.HeaderCell>Dirección</Table.HeaderCell>
                           <Table.HeaderCell>Unidad</Table.HeaderCell>
                           <Table.HeaderCell>Etapa</Table.HeaderCell>
                           {evaluadas && <Table.HeaderCell>Precalificada</Table.HeaderCell>}
                           {validadas && <Table.HeaderCell>Validada</Table.HeaderCell>}
                       </Table.Row>
                   </Table.Header>
                   <Table.Body>
                       {
                           pendientes.map((d,index)=>{
                            
                                return  <Table.Row key={`fila_${index}`}>
                                                <Table.Cell padded>{d["name_officer"]}</Table.Cell>
                                                <Table.Cell>{d["rut_officer"]}</Table.Cell>
                                                <Table.Cell>{d["nameDmunicipal"]}</Table.Cell>
                                                <Table.Cell>{d["nameUmunicipal"]}</Table.Cell>
                                                <Table.Cell>{d["name"]}</Table.Cell>
                                                {evaluadas && <Table.Cell textAlign='center'>
                                                    {d["statusQualificationPre"] ? 
                                                    <i className='fas fa-check text-success'></i>:
                                                    <i className='fas fa-times text-danger'></i>}
                                                </Table.Cell>}

                                                {validadas &&  <Table.Cell textAlign='center'>
                                                    {d["statusValidationFun"] ? 
                                                    <i className='fas fa-check text-success'></i>:
                                                    <i className='fas fa-times text-danger'></i>}
                                                </Table.Cell>}
                                               
                                        </Table.Row>  
                            }
                              
                           )
                       }
                    
                   </Table.Body>
              </Table>
                   :
                   <center>No hay evaluaciones pendientes</center>
                }       
            </Modal>   
    </div>
  )
}
